import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'app-formly-field-label',
  templateUrl: './formly-field-label.component.html',
  styleUrls: ['./formly-field-label.component.scss']
})
export class FormlyFieldLabelComponent extends FieldType
{

}
